import { UA_TO_GA4_ACTION_MAPPING } from '@/constants'

export default {
  methods: {
    trackGA ({ category, action, label }) {
      if (this.$isGA4Enabled) {
        action = UA_TO_GA4_ACTION_MAPPING[action]
      }

      const event = { action, label }

      // do not override category for GA4 events, use widget's global category
      if (category && !this.$isGA4Enabled) {
        event.category = category
      }

      this.$ppAnalytics.trackEvent(event)
    }
  }
}
